import React from 'react';

import Button from 'src/components/Button';
import EmailEditor from './EmailEditor';
import useGetRequest from '../../../hooks/useGetRequest';

function EditEmail({
  engagementId,
  onClose,
  recipients,
  setRecipients,
  ccs,
  setCcs,
  bccs,
  setBccs,
  subject,
  setSubject,
  body,
  setBody
}: any) {
  const [localRecipients, setLocalRecipients] = React.useState(recipients);
  const [localCcs, setLocalCcs] = React.useState(ccs);
  const [localBccs, setLocalBccs] = React.useState(bccs);
  const [localSubject, setLocalSubject] = React.useState(subject);
  const [localBody, setLocalBody] = React.useState(body);

  const {
    result: engagement,
    isLoading,
  } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/`,
  });

  if (isLoading) return null;

  const commitChanges = () => {
    setRecipients(localRecipients);
    setCcs(localCcs);
    setBccs(localBccs);
    setSubject(localSubject);
    setBody(localBody);
  };

  const actions = (
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; color: string; variant: ... Remove this comment to see the full error message
    <Button
      color="secondary"
      variant="contained"
      type="submit"
      onClick={() => {
        commitChanges();
        onClose();
      }}
    >
      Save
    </Button>
  );

  return (
    <EmailEditor
      workflowId={engagement.workflow.id}
      engagementId={engagementId}
      onClose={onClose}
      actions={actions}
      title="Edit message"
      recipients={localRecipients}
      setRecipients={setLocalRecipients}
      ccs={localCcs}
      setCcs={setLocalCcs}
      bccs={localBccs}
      setBccs={setLocalBccs}
      subject={localSubject}
      setSubject={setLocalSubject}
      body={localBody}
      setBody={setLocalBody}
    />
  );
}

export default EditEmail;
